import { m } from 'framer-motion';
import { Button, Typography } from '@mui/material';
import { MotionContainer, varBounce } from '../components/minimal/animate';
import { SeverErrorIllustration } from '../assets/illustrations';
import { Stack } from '@mui/system';
import { useLocales } from "../locales";

export default function DynamicError({ title, subtitle, actionBtnMsg, href, onActionBtnClick }) {
  const { translate } = useLocales();
  title = title || translate('event_page.error_fallback.title');
  subtitle = subtitle || translate('event_page.error_fallback.subtitle');
  actionBtnMsg = actionBtnMsg || translate('event_page.error_fallback.action_btn_msg');
  onActionBtnClick = onActionBtnClick || (() => window.location.reload());
  return (
    <Stack sx={{
      display: 'flex',
      justifyContent: 'center',
      height: '100vh',
    }}>
      <Stack spacing={2} sx={{ textAlign: 'center' }}>
        <MotionContainer>
          <m.div variants={varBounce().in}>
            <Typography variant="h4">
              {title}
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Typography variant="h6" sx={{ color: 'text.secondary', maxWidth: '450px', margin: 'auto' }}>
              {subtitle}
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <SeverErrorIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
          </m.div>

          {actionBtnMsg && <Button
            href={href}
            onClick={onActionBtnClick}
            size="large"
            variant="contained">
            {actionBtnMsg}
          </Button>}
        </MotionContainer>
      </Stack>
    </Stack>
  );
}
